if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(1(021|767|879)|3(105|36|5)|2695|547|5811|6918|7787|8371|8678|926)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}